module.exports = __webpack_public_path__ + "static/media/plus.e5262fd7.svg";